import { Body, Title } from '@vds/typography'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TextLink } from '@vds/buttons';
import { Modal, ModalBody, ModalTitle } from '@vds/modals';

const CountDown=({toDate,bodyContent='',holidayBannerTextcolor})=>{
    const [remainingDate,setRemainingDate] = useState(undefined)
    const [remainingHours,setRemainingHours] = useState(undefined)
    const [remainingMinutes,setRemainingMinutes] = useState(undefined)
    const [remainingSeconds,setRemainingSeconds] = useState(undefined)

    useEffect(()=>{
        setInterval(()=>{
            calcRemainingTime()
        },1000)
    },[])

    const calcRemainingTime = ()=>{
        const remainingTimeFrame = toDate - new Date()
        const TotalRemaingTime = String((remainingTimeFrame / (24*60*60*1000))).split('.')
        setRemainingDate(Number(TotalRemaingTime[0]))
        if(TotalRemaingTime.length > 1){
            const hoursRem = String((Number(('0.'+TotalRemaingTime[1])) * 24)).split('.')
            setRemainingHours( Number(hoursRem[0]))
            if(hoursRem.length > 1){
                const minutesRem = String((Number(('0.'+hoursRem[1])) * 60)).split('.')
                setRemainingMinutes(Number(minutesRem[0]))
                if(minutesRem.length > 1){
                    const seconds = String((Number(('0.'+minutesRem[1])) * 60)).split('.')
                    const secondsFinal = Number(seconds[0])
                    setRemainingSeconds(secondsFinal)
                }
            }
        }
    }
    if(remainingDate !== undefined && remainingDate !== null && remainingHours !== undefined && remainingHours !==null && remainingMinutes !== undefined && remainingMinutes !== null && remainingSeconds !== undefined && remainingSeconds !== null){
        const bodyContentFinal = String(bodyContent).replace("{{days_remaining}}",remainingDate).replace("{{hours_remaining}}",remainingHours)
        .replace("{{minutes_remaining}}",remainingMinutes).replace("{{seconds_remaining}}",remainingSeconds)
        return(
           <Body size="large" color={holidayBannerTextcolor} primitive='span'>{bodyContentFinal}</Body>
        )
    }
    return <></>
}


export const HolidayOfferBanner = ()=>{
    const {t,ready} = useTranslation(['customize-order'])
    const showOfferBanner = t("showHolidayOfferBanner",{ns:'customize-order'})
    const holidayBannerBGcolor = t("holidayOfferBannerBGcolor",{ns:'customize-order'}) !== "holidayOfferBannerBGcolor" ? t("holidayOfferBannerBGcolor",{ns:'customize-order'}) : '#e3f2fd'
    const holidayBannerTextcolor = t("holidayBannerTextcolor",{ns:'customize-order'}) !== "holidayBannerTextcolor" ? t("holidayBannerTextcolor",{ns:'customize-order'}) : '#000000'
    const [openModal,setOpenModal] = useState(false)
    if(showOfferBanner){
    return(
        <div className="NavHeader-hol">
        <div style={{width:'100%',backgroundColor:holidayBannerBGcolor,padding:'1rem'}}>
            <div style={{display:'flex',alignItems:'flex-start'}}>
            <ClockImage/>&nbsp;
            <div>
            <Body size="large" inverted={true} color='black' bold={false} primitive='span'>
                <span dangerouslySetInnerHTML={{__html:t("holidayOffeBannerTitle")}}/>&nbsp;
                <TextLink color={holidayBannerTextcolor} onClick={()=>setOpenModal(true)}>{t("holdayOfferBannerTextLink")}</TextLink>&nbsp;
                <span dangerouslySetInnerHTML={{__html:t("holdayOfferBannerTitleRemainingContent")}}/>
            </Body>
            <div style={{marginTop:'5px'}} />
            <CountDown toDate={new Date(t("holidayOffeBannerEndDate"))} bodyContent = {t("holidayOffeBannerText")} holidayBannerTextcolor={holidayBannerTextcolor}/>
            </div>
            </div>
           <DetailsModal opened={openModal} content={t("holidayOfferModalContent")} onOpenedChange = {(val)=>{
            if(!val) setOpenModal(val)
           }}/>
        </div>
        </div>
    )
}else return <></>
}

const ClockImage = ()=>{
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M19.0697 19.0698C17.6715 20.4685 15.8898 21.4211 13.9501 21.8071C12.0104 22.1931 9.9998 21.9952 8.17257 21.2384C6.34535 20.4816 4.78361 19.1999 3.68488 17.5555C2.58616 15.911 1.99981 13.9776 2 11.9999H3.25C3.25025 13.7301 3.76353 15.4213 4.72494 16.8598C5.68634 18.2983 7.0527 19.4195 8.65125 20.0815C10.2498 20.7435 12.0087 20.9166 13.7057 20.579C15.4026 20.2414 16.9613 19.4082 18.1848 18.1848C19.4082 16.9613 20.2414 15.4026 20.579 13.7057C20.9166 12.0087 20.7435 10.2498 20.0815 8.65122C19.4195 7.05268 18.2983 5.68633 16.8598 4.72492C15.4213 3.76352 13.73 3.25025 11.9998 3.25V6.64828H10.7498V2H11.9998C13.9776 1.99978 15.911 2.58611 17.5555 3.68483C19.2 4.78355 20.4817 6.3453 21.2385 8.17253C21.9953 9.99977 22.1932 12.0104 21.8071 13.9501C21.4211 15.8898 20.4685 17.6715 19.0697 19.0697V19.0698ZM14.2178 11.8663C14.2178 12.5302 13.9541 13.1669 13.4846 13.6363C13.0152 14.1057 12.3785 14.3695 11.7146 14.3695C11.0507 14.3695 10.414 14.1057 9.94461 13.6363C9.47517 13.1669 9.21145 12.5302 9.21145 11.8663C9.21145 11.8511 9.21561 11.8372 9.21589 11.8222L3.25 10.1449L3.58831 8.94667L9.55309 10.6251C9.82567 10.1458 10.2493 9.77032 10.7578 9.55722C11.2664 9.34412 11.8311 9.30544 12.364 9.44722C12.8968 9.589 13.3677 9.90325 13.7031 10.3409C14.0384 10.7785 14.2194 11.3149 14.2178 11.8663ZM13.0511 11.8663C13.0511 11.602 12.9727 11.3436 12.8259 11.1238C12.679 10.904 12.4703 10.7327 12.226 10.6316C11.9818 10.5304 11.7131 10.504 11.4539 10.5555C11.1946 10.6071 10.9565 10.7344 10.7696 10.9213C10.5827 11.1082 10.4554 11.3463 10.4038 11.6056C10.3522 11.8648 10.3787 12.1336 10.4798 12.3778C10.581 12.622 10.7523 12.8307 10.9721 12.9776C11.1918 13.1244 11.4502 13.2028 11.7146 13.2028C12.0689 13.2025 12.4087 13.0615 12.6592 12.811C12.9098 12.5604 13.0507 12.2207 13.0511 11.8663Z" fill="black"/>
        </svg>
    )
}

const DetailsModal = ({opened=false,content="",onOpenedChange=()=>{}})=>{
    return(
        <Modal opened={opened} onOpenedChange={onOpenedChange} id="holday-offer-modal">
        <ModalBody> 
            {content}
        </ModalBody>
    </Modal>
    )
}